<div class="login-modal">
  <header class="modal__header">
    <h2 [ngStyle]="color && { color: 'black' }">{{ "user.label.login_to_airmiles" | translate }}</h2>
    <a class="button button--transparent modal__button--close" (click)="closeModal(true, true)">
      <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
    </a>
  </header>
  <div class="modal__content">
    <air-form
      #formComponent
      [controls]="form"
      [alternateReCaptchaActions]="[reCaptchaAction]"
      [userEventSource]="userEventSource"
      (submitted)="submitValues($event)"
    >
      <p
        *ngIf="partnerNotice"
        class="login-modal__partner-notice"
        [internalInnerHtml]="partnerNotice"
        [userEventSource]="userEventSource"
      ></p>

      <div class="button__group--column">
        <button
          type="button"
          (click)="submit($event)"
          class="button form__button button--cta"
          [airButtonLoading]="isSubmitting"
          [class.button--disabled]="formDisabled"
          [ngStyle]="color && { 'background-color': '#' + color.color }"
        >
          <span>{{ "user.label.login" | translate }}</span>
        </button>
        <a class="button button--secondary" (click)="openPasswordResetModal($event)" [ngStyle]="color && { color: '#' + color.color }">
          <span>{{ "user.label.cannot_login" | translate }}</span>
        </a>
        <ng-container *ngIf="!alternateMode">
          <hr />
          <a class="button button--border" (click)="goToRegistrationPage($event)">
            <span>{{ "user.label.register" | translate }}</span>
          </a>
        </ng-container>
      </div>
    </air-form>
  </div>
</div>
